/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { categoryControllerCreate } from '../fn/category/category-controller-create';
import { CategoryControllerCreate$Params } from '../fn/category/category-controller-create';
import { categoryControllerDelete } from '../fn/category/category-controller-delete';
import { CategoryControllerDelete$Params } from '../fn/category/category-controller-delete';
import { categoryControllerFindAll } from '../fn/category/category-controller-find-all';
import { CategoryControllerFindAll$Params } from '../fn/category/category-controller-find-all';
import { categoryControllerFindById } from '../fn/category/category-controller-find-by-id';
import { CategoryControllerFindById$Params } from '../fn/category/category-controller-find-by-id';
import { categoryControllerSearchCursor } from '../fn/category/category-controller-search-cursor';
import { CategoryControllerSearchCursor$Params } from '../fn/category/category-controller-search-cursor';
import { categoryControllerSearchOffset } from '../fn/category/category-controller-search-offset';
import { CategoryControllerSearchOffset$Params } from '../fn/category/category-controller-search-offset';
import { categoryControllerUpdate } from '../fn/category/category-controller-update';
import { CategoryControllerUpdate$Params } from '../fn/category/category-controller-update';
import { CategoryDto } from '../models/category-dto';
import { CategorySearchResponseDto } from '../models/category-search-response-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';

@Injectable({ providedIn: 'root' })
export class CategoryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `categoryControllerFindAll()` */
  static readonly CategoryControllerFindAllPath = '/api/category';

  /**
   * 모든 카테고리 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryControllerFindAll$Response(params?: CategoryControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CategoryDto>>> {
    return categoryControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 카테고리 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categoryControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryControllerFindAll(params?: CategoryControllerFindAll$Params, context?: HttpContext): Observable<Array<CategoryDto>> {
    return this.categoryControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CategoryDto>>): Array<CategoryDto> => r.body)
    );
  }

  /** Path part for operation `categoryControllerCreate()` */
  static readonly CategoryControllerCreatePath = '/api/category';

  /**
   * 카테고리 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categoryControllerCreate$Response(params: CategoryControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CategoryDto>> {
    return categoryControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 카테고리 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categoryControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categoryControllerCreate(params: CategoryControllerCreate$Params, context?: HttpContext): Observable<CategoryDto> {
    return this.categoryControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CategoryDto>): CategoryDto => r.body)
    );
  }

  /** Path part for operation `categoryControllerSearchOffset()` */
  static readonly CategoryControllerSearchOffsetPath = '/api/category/search/offset';

  /**
   * 카테고리 오프셋 기반 조회.
   *
   * 카테고리을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryControllerSearchOffset$Response(params: CategoryControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<CategorySearchResponseDto>> {
    return categoryControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 카테고리 오프셋 기반 조회.
   *
   * 카테고리을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categoryControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryControllerSearchOffset(params: CategoryControllerSearchOffset$Params, context?: HttpContext): Observable<CategorySearchResponseDto> {
    return this.categoryControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<CategorySearchResponseDto>): CategorySearchResponseDto => r.body)
    );
  }

  /** Path part for operation `categoryControllerSearchCursor()` */
  static readonly CategoryControllerSearchCursorPath = '/api/category/search/cursor';

  /**
   * 카테고리 커서 기반 조회.
   *
   * 카테고리을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryControllerSearchCursor$Response(params: CategoryControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return categoryControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 카테고리 커서 기반 조회.
   *
   * 카테고리을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categoryControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryControllerSearchCursor(params: CategoryControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.categoryControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `categoryControllerFindById()` */
  static readonly CategoryControllerFindByIdPath = '/api/category/{id}';

  /**
   * 카테고리 ID 기반 조회.
   *
   * 카테고리를 ID 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryControllerFindById$Response(params: CategoryControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CategoryDto>> {
    return categoryControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 카테고리 ID 기반 조회.
   *
   * 카테고리를 ID 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categoryControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryControllerFindById(params: CategoryControllerFindById$Params, context?: HttpContext): Observable<CategoryDto> {
    return this.categoryControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CategoryDto>): CategoryDto => r.body)
    );
  }

  /** Path part for operation `categoryControllerDelete()` */
  static readonly CategoryControllerDeletePath = '/api/category/{id}';

  /**
   * 카테고리 삭제.
   *
   * 카테고리를 삭제합니다
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryControllerDelete$Response(params: CategoryControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CategoryDto>> {
    return categoryControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 카테고리 삭제.
   *
   * 카테고리를 삭제합니다
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categoryControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryControllerDelete(params: CategoryControllerDelete$Params, context?: HttpContext): Observable<CategoryDto> {
    return this.categoryControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CategoryDto>): CategoryDto => r.body)
    );
  }

  /** Path part for operation `categoryControllerUpdate()` */
  static readonly CategoryControllerUpdatePath = '/api/category/{id}';

  /**
   * 카테고리 수정.
   *
   * 카테고리를 수정합니다
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categoryControllerUpdate$Response(params: CategoryControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CategoryDto>> {
    return categoryControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 카테고리 수정.
   *
   * 카테고리를 수정합니다
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categoryControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categoryControllerUpdate(params: CategoryControllerUpdate$Params, context?: HttpContext): Observable<CategoryDto> {
    return this.categoryControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CategoryDto>): CategoryDto => r.body)
    );
  }

}
